import { IFeatureRepository } from "api/merchantRepository/features/FeatureRepository";
import { IFilterFeatureRepository } from "api/merchantRepository/filterFeature/FilterFeatureRepository";
import { INotificationRepository } from "api/merchantRepository/notification/NotificationRepository";
import { ISupportFeatureRepository } from "api/merchantRepository/supportFeature/SupportFeatureRepository";
import { IAppTransactionRepository } from "api/repositories/appTransaction/AppTransactionRepository";
import { ICarrierRepository } from "api/repositories/carrier/CarrierRepository";
import { ITopupManagementRepository } from "api/repositories/packagesManagement/topupManagement/TopupManagementRepository";
import { IPartnerManagementRepository } from "api/repositories/partnerManagement/PartnerManagementRepository";
import { IRoamingPartnerRepository } from "api/repositories/roamingPartnerManagement/RoamingPartnerRepository";
import { IRoleRepository } from "api/repositories/rolesList/RolesListRepository";
import { SupplierManagementToken } from "features/supplierManagement/di/SupplierManagementToken";
import { DependenciesInjection } from "app/di/DependencyInjection";
import { InjectionToken } from "utils/injectionToken/InjectionToken";

//Class khai báo repo thay cho method DependenciesInjection.getRepo để tránh khai báo dài dòng
export class ServiceRepo {
  static getAppTransactionRepo() {
    return DependenciesInjection.getRepo<IAppTransactionRepository>(
      InjectionToken.IAppTransactionRepository,
    );
  }
  static getCarrierRepo() {
    return DependenciesInjection.getRepo<ICarrierRepository>(
      InjectionToken.ICarrierRepository,
    );
  }
  static getSupportFeatureRepo() {
    return DependenciesInjection.getRepo<ISupportFeatureRepository>(
      InjectionToken.ISupportFeatureRepository,
    );
  }
  static getFilterFeatureRepo() {
    return DependenciesInjection.getRepo<IFilterFeatureRepository>(
      InjectionToken.IFilterFeatureRepository,
    );
  }
  static getNotificationRepo() {
    return DependenciesInjection.getRepo<INotificationRepository>(
      InjectionToken.INotificationRepository,
    );
  }
  static getPackageManagementRepo() {
    return DependenciesInjection.getRepo<ITopupManagementRepository>(
      InjectionToken.ITopupManagementRepository,
    );
  }
  static getRoamingPartnerRepo() {
    return DependenciesInjection.getRepo<IRoamingPartnerRepository>(
      InjectionToken.IRoamingPartnerRepository,
    );
  }
  static getPartnerManagementRepo() {
    return DependenciesInjection.getRepo<IPartnerManagementRepository>(
      InjectionToken.IPartnerManagementRepository,
    );
  }
  static getFeatureRepo() {
    return DependenciesInjection.getRepo<IFeatureRepository>(
      InjectionToken.IFeatureRepository,
    );
  }
  static getPartnerRepo() {
    return DependenciesInjection.getRepo<IPartnerManagementRepository>(
      InjectionToken.IPartnerManagementRepository,
    );
  }
  static getRoleRepo() {
    return DependenciesInjection.getRepo<IRoleRepository>(
      InjectionToken.IRoleRepository,
    );
  }

  static getSupplierRepo() {
    return DependenciesInjection.getRepo<any>(
      SupplierManagementToken.ISupplierManagementRepository,
    );
  }
}
